import React, { useState } from "react";
import { Link } from "react-router-dom";

// image
import logo from "../../images/logo.png";
// import loginImage from "../../images/IMG_20250630_133148_038.jpg";
// import loginImage from "../../images/2ad5481b-b0e7-4639-9dfe-50640a105951.jpeg";
import loginImage from "../../images/WhatsApp_Image_.jpeg";
// import loginImage from "../../images/098beb43-ada4-4ce0-946f-6cb7a870001f.jpeg";
const Login = ({ history }) => {
  const [email, setEmail] = useState("admin");
  const [password, setPassword] = useState("admin");
  const [error, setError] = useState("");

  const submitHandler = (e) => {
    e.preventDefault();

    localStorage.setItem(
      "user",
      JSON.stringify({
        uid: 2,
        is_system: true,
        is_admin: true,
        is_public: false,
        is_internal_user: true,
        user_context: {
          lang: "ar_001",
          tz: "Asia/Riyadh",
          uid: 2,
        },
        db: "PLO-v2",
        user_settings: {
          id: 1,
          user_id: { id: 2 },
          is_discuss_sidebar_category_channel_open: true,
          is_discuss_sidebar_category_chat_open: true,
          push_to_talk_key: false,
          use_push_to_talk: false,
          voice_active_duration: 200,
          volume_settings_ids: [["ADD", []]],
        },
        server_version: "17.0-20241029",
        server_version_info: [17, 0, 0, "final", 0, ""],
        support_url: "https://www.odoo.com/buy",
        name: "Administrator",
        username: "admin",
        partner_display_name: "Administrator",
        partner_id: 3,
        "web.base.url": "http://plo.areez.co",
        active_ids_limit: 20000,
        profile_session: null,
        profile_collectors: null,
        profile_params: null,
        max_file_upload_size: 134217728,
        home_action_id: false,
        cache_hashes: {
          translations: "ab341b793618839b828838fd5c56ee751695bc2a",
          load_menus:
            "018bbd81c0fa7e6c80c46547ac1111bee162e31c36a1c1481611ae3569331615",
        },
        currencies: {
          1: {
            symbol: "$",
            position: "before",
            digits: [69, 2],
          },
          151: {
            symbol: "SR",
            position: "after",
            digits: [69, 2],
          },
        },
        bundle_params: {
          lang: "ar_001",
        },
        user_companies: {
          current_company: 1,
          allowed_companies: {
            1: {
              id: 1,
              name: "شركة أريز",
              sequence: 0,
              child_ids: [],
              parent_id: false,
            },
            2: {
              id: 2,
              name: "جامعة اليمامة - AlYamamah University",
              sequence: 10,
              child_ids: [],
              parent_id: false,
            },
          },
          disallowed_ancestor_companies: {},
        },
        show_effect: true,
        display_switch_company_menu: true,
        user_id: [2],
        websocket_worker_version: "17.0-1",
        web_tours: [],
        tour_disable: false,
        preloader_option: "style_eight",
        menu_bg_image: false,
        dark_mode: false,
        notification_type: "email",
        odoobot_initialized: true,
        iap_company_enrich: false,
      })
    );

    // localStorage.setItem("user", {"uid":2,"is_system":true,"is_admin":true,"is_public":false,"is_internal_user":true,"user_context":{"lang":"ar_001","tz":"Asia/Riyadh","uid":2},"db":"PLO-v2","user_settings":{"id":1,"user_id":{"id":2},"is_discuss_sidebar_category_channel_open":true,"is_discuss_sidebar_category_chat_open":true,"push_to_talk_key":false,"use_push_to_talk":false,"voice_active_duration":200,"volume_settings_ids":[["ADD",[]]]},"server_version":"17.0-20241029","server_version_info":[17,0,0,"final",0,""],"support_url":"https://www.odoo.com/buy","name":"Administrator","username":"admin","partner_display_name":"Administrator","partner_id":3,"web.base.url":"http://plo.areez.co","active_ids_limit":20000,"profile_session":null,"profile_collectors":null,"profile_params":null,"max_file_upload_size":134217728,"home_action_id":false,"cache_hashes":{"translations":"ab341b793618839b828838fd5c56ee751695bc2a","load_menus":"018bbd81c0fa7e6c80c46547ac1111bee162e31c36a1c1481611ae3569331615"},"currencies":{"1":{"symbol":"$","position":"before","digits":[69,2]},"151":{"symbol":"SR","position":"after","digits":[69,2]}},"bundle_params":{"lang":"ar_001"},"user_companies":{"current_company":1,"allowed_companies":{"1":{"id":1,"name":"شركة أريز","sequence":0,"child_ids":[],"parent_id":false},"2":{"id":2,"name":"جامعة اليمامة - AlYamamah University","sequence":10,"child_ids":[],"parent_id":false}},"disallowed_ancestor_companies":{}},"show_effect":true,"display_switch_company_menu":true,"user_id":[2],"websocket_worker_version":"17.0-1","web_tours":[],"tour_disable":false,"preloader_option":"style_eight","menu_bg_image":false,"dark_mode":false,"notification_type":"email","odoobot_initialized":true,"iap_company_enrich":false});
    history.push("/");
  };
  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   try {

  //     fetch("https://plo.areez.co/web/session/authenticate", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         params: {
  //           db: "PLO-v2",
  //           login: email,
  //           password: password,
  //         },
  //       }),
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data.result && data.result.uid) {
  //           localStorage.setItem("user", JSON.stringify(data.result));
  //           window.location.href = "/";
  //         } else {
  //           alert("Login failed");
  //         }
  //       })
  //       .catch((err) => {
  //         console.error("Login error:", err);
  //       });
  //   } catch (err) {
  //     console.error(err);
  //     setError("حدث خطأ أثناء الاتصال بالخادم.");
  //   }
  // };

  return (
    <div className="container-fluid">
    <div className="row">
      
      <div className="col-md-6 d-none d-md-flex align-items-center justify-content-center p-0">
        <img
          src={loginImage}
          alt="Login Visual"
          style={{
            height: "100vh",
            width:"100%"
          }}
        />
      </div>
  
      <div className="col-md-6 d-flex align-items-center justify-content-center">
        <div className="w-75">
          <h4 className="text-center mb-4">تسجيل الدخول إلى حسابك</h4>
          <form onSubmit={submitHandler}>
            <div className="form-group">
              <label><strong>البريد الإلكتروني</strong></label>
              <input
                type="text"
                className="form-control"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label><strong>كلمة السر</strong></label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <div className="text-center mt-4">
              <button type="submit" className="btn btn-primary btn-block">
                تسجيل دخول
              </button>
            </div>
          </form>
        </div>
      </div>
      
    </div>
  </div>
  
  );
};

export default Login;
